/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
import { IconName } from 'app/common/components/controls/icon';
import { InfoMenuPopoverId } from 'app/gamma/src/components/popovers/popover-ids';
import { showPopover, State } from 'app/gamma/src/modules';
import React, { lazy, Suspense } from 'react';
import { connect, Dispatch } from 'react-redux';
import { isPopoverShown } from 'app/gamma/src/selectors/popovers';

import { Noun, Verb, trackUe } from '@trello/analytics';
import HeaderButton from './button';

const HeaderInfoMenuPopoverPromise = import(/* webpackChunkName: "info-menu-popover" */ 'app/gamma/src/components/popovers/header-info-menu');
const HeaderInfoMenuPopover = lazy(() => HeaderInfoMenuPopoverPromise);

interface Props {
  isActive: boolean;
  onClick: React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
}

class InfoMenuButton extends React.Component<Props> {
  infoButtonRef = React.createRef<HTMLButtonElement>();

  render() {
    const { isActive, onClick }: Props = this.props;

    return (
      <>
        <HeaderButton
          icon={IconName.Information}
          onClick={onClick}
          ref={this.infoButtonRef}
          testId={HeaderTestIds.InfoButton}
        />
        {isActive && (
          <Suspense fallback={null}>
            <HeaderInfoMenuPopover target={() => this.infoButtonRef.current} />
          </Suspense>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: State) => {
  return {
    isActive: isPopoverShown(state, InfoMenuPopoverId),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<State>) => {
  return {
    onClick(e: React.MouseEvent<HTMLElement>) {
      trackUe({
        category: Noun.HEADER,
        verb: Verb.OPENS,
        directObj: Noun.INFO_MENU,
        method: 'clicking info header button',
      });

      dispatch(showPopover({ name: InfoMenuPopoverId }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InfoMenuButton);
